import { ReactComponent as IconCar } from '../../../../icons/car.svg';
import { ReactComponent as IconDepartment } from '../../../../icons/house.svg';
import { ReactComponent as IconParcel } from '../../../../icons/parcel.svg';
import { ReactComponent as IconHouse } from '../../../../icons/postoffice.svg';

export const getIconByServiceCode = (code: string) => {
	switch (code) {
		case '0': {
			return IconParcel;
		}
		case '1': {
			return IconHouse;
		}
		case '2': {
			return IconCar;
		}
		case '3': {
			return IconCar;
		}
		case '4': {
			return IconDepartment;
		}
		default: {
			return IconCar;
		}
	}
};
